var _a;
import * as React from 'react';
import { createSvgIcon, IconDirectionality } from '..';
export var Circle = createSvgIcon((_a = {},
    _a[IconDirectionality.All] = (React.createElement(React.Fragment, null,
        React.createElement("rect", { width: "14", height: "14", x: "1", y: "1", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", rx: "7" }))),
    _a), 'small');
//# sourceMappingURL=Circle.js.map